import { Button } from '@neo/primitives/button'
import { ReactComponent as IcMcp } from '@shared/assets/icons/ic-mcp.svg'

export const AddMcpButton = ({ onClick }: { onClick: () => void }) => (
  <Button
    variant="outline"
    onClick={onClick}
    // `text-p-400` matches the search field beside it; the default 500 weight reads as larger.
    className="flex-none gap-1.5 text-p-400"
    data-testid="button-add-mcp-toolbar"
  >
    {/* 20px, larger than its neighbours: the mark's sparse strokes read smaller at equal size. */}
    <IcMcp className="h-5 w-5" />
    Add Custom MCP
  </Button>
)
